import { useCallback, useEffect, useState } from 'react';

export function useNotice(durationMs = 4200) {
  const [notice, setNotice] = useState(null);

  const showNotice = useCallback((message, type = 'info') => {
    if (!message) return;
    setNotice({ id: Date.now(), message, type });
  }, []);

  const clearNotice = useCallback(() => {
    setNotice(null);
  }, []);

  useEffect(() => {
    if (!notice) return undefined;
    const timeoutId = window.setTimeout(() => {
      setNotice(null);
    }, durationMs);

    return () => window.clearTimeout(timeoutId);
  }, [notice, durationMs]);

  return { notice, showNotice, clearNotice };
}
